import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { renderTableTitle } from "@/utils/render.jsx";
import { compensateDownstreamAccounts, getDownstreamAlertCandidates, getDownstreamLogDetail, getDownstreamLogsPage, manualBindDownstreamAlert, repushDownstreamAccounts } from "@/service/sync-manage";
import { emptyTableResponse, formatTime, tableFirstResult } from "./sync-utils";
const DEFAULT_LOG_SYSTEMS = ["UC", "IHOTEL", "ICATER"];
const MULTIPLE_MATCHED_REASON = "MULTIPLE_MATCHED";
const UNIT_CODE_NOT_MATCHED_REASON = "UNIT_CODE_NOT_MATCHED";
const RESULT_SUCCESS = "SUCCESS";
const RESULT_FAILED = "FAILED";
const RESULT_PENDING = "PENDING";
const LOG_TABLE_BOTTOM_GAP = 16;
const DEFAULT_LOG_FILTERS = {
  downstreamSystem: "ALL",
  result: "ALL",
  dateRange: "TODAY",
  search: ""
};
const EVENT_TYPE_TEXT = {
  1: $t("8rsdkl7", "成员新增/更新"),
  2: $t("b3vqs47", "成员删除/离职"),
  3: $t("cgdfh7", "部门新增/更新"),
  4: $t("iwby9w4", "部门删除"),
  5: $t("a0zr9h6", "定期全量同步")
};
export default {
  name: "sync-logs-tab",
  props: {
    appId: {
      type: String,
      default: ""
    },
    unitCode: {
      type: String,
      default: ""
    },
    downstreamOptions: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      filters: {
        ...DEFAULT_LOG_FILTERS
      },
      detailModal: {
        visible: false,
        row: null,
        loading: false,
        payload: "—"
      },
      retryModal: {
        visible: false,
        saving: false,
        row: null,
        systems: [],
        systemOptions: []
      },
      candidateModal: {
        visible: false,
        saving: false,
        row: null,
        candidates: [],
        selectedKey: ""
      },
      tableHeightValue: Math.max(window.innerHeight - 390, 300),
      tableHeightAdjusting: false
    };
  },
  computed: {
    logDownstreamOptions() {
      // 日志筛选固定展示三类下游，避免当前只有 UC 数据时无法手动筛选 iHotel/iCater。
      const systems = [...this.downstreamOptions.map(item => item.value), ...DEFAULT_LOG_SYSTEMS].filter(Boolean);
      return [...new Set(systems)].map(system => ({
        value: system
      }));
    },
    candidateWarningText() {
      const row = this.candidateModal.row || {};
      return $t("s1xof642", "${this.shortSystemName(this.primarySystem(row))} \u4E2D\u5B58\u5728 ${this.candidateModal.candidates.length} \u4E2A\u540C\u540D\u8D26\u53F7\u300C${this.memberName(row)}\u300D\uFF0C\u65E0\u6CD5\u81EA\u52A8\u552F\u4E00\u786E\u5B9A\uFF0C\u8BF7\u9009\u62E9\u6B63\u786E\u8D26\u53F7\u8FDB\u884C\u5173\u8054\u3002", {
        "this.shortSystemName(this.primarySystem(row))": this.shortSystemName(this.primarySystem(row)),
        "this.candidateModal.candidates.length": this.candidateModal.candidates.length,
        "this.memberName(row)": this.memberName(row)
      });
    },
    tableConfig() {
      return {
        autoFetch: false,
        columns: this.columns,
        map: {
          dataPath: "retVal.datas",
          message: "msg",
          totalPath: "retVal.totalRows"
        },
        format: {
          formatCurrent: "(page.current - 1) * page.pageSize"
        },
        request: this.queryLogs,
        table: {
          border: false,
          draggable: false,
          height: this.tableHeight,
          "row-class-name": this.rowClassName
        },
        page: {
          "show-elevator": false
        },
        hide: {
          search: true,
          toolBar: true
        }
      };
    },
    tableHeight() {
      return this.tableHeightValue;
    },
    columns() {
      return [{
        title: $t("i5z22", "时间"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "resultTime",
        minWidth: 180,
        notShowSearch: true,
        notShowForm: true
      }, {
        title: $t("h5542", "成员"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "userName",
        minWidth: 140,
        tooltip: true,
        notShowSearch: true,
        notShowForm: true,
        renderTable: (h, {
          row
        }) => this.textCell(h, this.memberName(row), "strong")
      }, {
        title: $t("a8stq34", "事件类型"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "eventType",
        minWidth: 160,
        tooltip: true,
        notShowSearch: true,
        notShowForm: true,
        renderTable: (h, {
          row
        }) => this.textCell(h, this.eventText(row), "strong")
      }, {
        title: $t("ffv07x4", "目标系统"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "downstreamSystem",
        minWidth: 160,
        notShowSearch: true,
        notShowForm: true,
        renderTable: (h, {
          row
        }) => this.renderSystemTags(h, row)
      }, {
        title: $t("pawp2", "通道"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "channel",
        minWidth: 140,
        notShowSearch: true,
        notShowForm: true,
        // 列表按目标系统展示通道口径：iHotel 统一显示 API，其余系统保持原文案。
        renderTable: (h, {
          row
        }) => this.tagNode(h, this.channelText(row, true), "channel")
      }, {
        title: $t("m52h2", "结果"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "result",
        minWidth: 110,
        notShowSearch: true,
        notShowForm: true,
        renderTable: (h, {
          row
        }) => this.tagNode(h, this.resultText(row), this.resultClass(row))
      }, {
        title: $t("hkxb2", "操作"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "action",
        width: 110,
        align: "center",
        notShowSearch: true,
        notShowForm: true,
        renderTable: (h, {
          row
        }) => this.renderAction(h, row)
      }];
    },
    detailPayload() {
      if (this.detailModal.loading) return $t("27k1ha6", "加载中...");
      return this.formatCodeBlock(this.detailModal.payload);
    }
  },
  mounted() {
    this.updateTableHeight();
    window.addEventListener("resize", this.updateTableHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateTableHeight);
  },
  methods: {
    resetFilters() {
      this.filters = {
        ...DEFAULT_LOG_FILTERS
      };
    },
    // 搜索区重置需要恢复默认条件后立即重新拉取列表，避免界面回到默认值但数据仍停留在旧筛选结果。
    resetSearch() {
      this.resetFilters();
      this.searchTable();
    },
    refresh(reset = false) {
      return new Promise(resolve => {
        this.$nextTick(() => {
          this.updateTableHeight();
          const table = this.$refs.proTable;
          if (table) {
            reset && table.searchAction ? table.searchAction() : table.fetch();
          }
          resolve();
        });
      });
    },
    // 根据当前 Tab 可视区域反推表格高度，保证同步日志列表卡片底部只保留 16px。
    updateTableHeight() {
      if (this.tableHeightAdjusting) return;
      this.tableHeightAdjusting = true;
      this.$nextTick(() => {
        const panel = this.$el;
        const table = panel === null || panel === void 0 ? void 0 : panel.querySelector(".sync-log-table");
        const panelRect = panel === null || panel === void 0 ? void 0 : panel.getBoundingClientRect();
        const tableRect = table === null || table === void 0 ? void 0 : table.getBoundingClientRect();
        if (panelRect !== null && panelRect !== void 0 && panelRect.height && tableRect !== null && tableRect !== void 0 && tableRect.height) {
          const currentGap = panelRect.bottom - tableRect.bottom;
          const nextHeight = Math.max(this.tableHeightValue + currentGap - LOG_TABLE_BOTTOM_GAP, 300);
          if (Math.abs(nextHeight - this.tableHeightValue) > 1) {
            this.tableHeightValue = nextHeight;
          }
        }
        this.$nextTick(() => {
          this.tableHeightAdjusting = false;
        });
      });
    },
    searchTable() {
      this.refresh(true);
    },
    // 同步日志查询仅调用日志分页接口，筛选条件按文档字段传递给后端。
    async queryLogs(search = {}) {
      if (!this.unitCode) {
        return emptyTableResponse();
      }
      const {
        startTime,
        endTime
      } = this.dateRangePayload();
      const resultPayload = this.resultFilterPayload();
      const {
        data
      } = await getDownstreamLogsPage({
        appId: this.appId,
        unitCode: this.unitCode,
        downstreamSystem: this.filters.downstreamSystem === "ALL" ? undefined : this.filters.downstreamSystem,
        ...resultPayload,
        search: this.filters.search || undefined,
        startTime,
        endTime,
        firstResult: tableFirstResult(search),
        pageSize: search.pageSize || 20
      });
      return data;
    },
    // 结果筛选按日志接口业务 result 枚举传递，不再使用 webhook 投递 state。
    resultFilterPayload() {
      if (this.filters.result === "ALL") return {};
      return {
        results: [this.filters.result]
      };
    },
    // 日志结果以聚合接口 result 为唯一业务状态；result 为空时不能再按旧投递 state 误判成功。
    normalizedResult(row) {
      const result = String(row.result || "").toUpperCase();
      if ([RESULT_SUCCESS, RESULT_FAILED, RESULT_PENDING].includes(result)) {
        return result;
      }
      return result;
    },
    normalizedFailureReason(row) {
      return String(row.failureReason || "").trim().toUpperCase();
    },
    needsHandle(row) {
      const failureReason = this.normalizedFailureReason(row);
      if (failureReason === MULTIPLE_MATCHED_REASON || failureReason === UNIT_CODE_NOT_MATCHED_REASON) {
        return true;
      }
      return this.normalizedResult(row) !== RESULT_SUCCESS;
    },
    isMultipleMatchedLog(row) {
      return this.normalizedFailureReason(row) === MULTIPLE_MATCHED_REASON;
    },
    isPendingWithoutFailureReason(row) {
      return !this.normalizedFailureReason(row) && this.normalizedResult(row) === RESULT_PENDING;
    },
    // failureReason 为空时，仅 FAILED 视作单位未匹配同类处理；PENDING 仍需走补偿查询接口。
    isUnitCodeNotMatchedLog(row) {
      const failureReason = this.normalizedFailureReason(row);
      return failureReason === UNIT_CODE_NOT_MATCHED_REASON || !failureReason && this.normalizedResult(row) === RESULT_FAILED;
    },
    primarySystem(row) {
      return this.systemList(row)[0] || row.downstreamSystem || "";
    },
    retryTargetSystems(row) {
      const systems = [...this.systemList(row), ...this.downstreamOptions.map(item => item.value), ...DEFAULT_LOG_SYSTEMS].filter(Boolean);
      return [...new Set(systems)];
    },
    retrySystemOptions(row) {
      return this.retryTargetSystems(row).map(system => ({
        value: system,
        shortName: this.shortSystemName(system),
        businessName: this.businessSystemName(system)
      }));
    },
    businessSystemName(system) {
      const names = {
        UC: $t("f6qc1x4", "用户中心"),
        IHOTEL: "PMS",
        ICATER: $t("jy2n374", "餐饮管理")
      };
      return names[system] || this.shortSystemName(system);
    },
    operationResult(data) {
      this.$emit("operation-result", data);
    },
    async refreshAfterOperation() {
      await this.refresh();
      this.$emit("refresh-alert-count");
    },
    candidateKey(item, index) {
      return [item.downstreamUserKey || "", item.downstreamUserCode || "", index].join("__");
    },
    candidateAccountName(item) {
      return item.downstreamUserCode || item.userName || "—";
    },
    candidateDepartmentName(item) {
      return item.departmentName || item.departmentCode || "—";
    },
    candidateCreateDate(value) {
      return formatTime(value);
    },
    canHandleAsCandidate(row) {
      return Boolean(this.primarySystem(row) && (row === null || row === void 0 ? void 0 : row.userCode));
    },
    canHandleAsRetry(row) {
      return Boolean((row === null || row === void 0 ? void 0 : row.userCode) && this.retryTargetSystems(row).length);
    },
    // 同步日志处理前优先区分是否缺少用户代码，避免统一提示“请选择目标系统”误导排查。
    warnMissingHandleContext(row, {
      requireSystem = true
    } = {}) {
      if (!(row !== null && row !== void 0 && row.userCode)) {
        this.$Message.warning($t("2rz0usb", "当前用户缺少用户代码！"));
        return true;
      }
      if (requireSystem && !this.primarySystem(row)) {
        this.$Message.warning($t("z8gsk47", "请选择目标系统"));
        return true;
      }
      return false;
    },
    // 单位未匹配或普通失败日志按图中重试弹窗处理，可选择一个或多个下游系统重推。
    openRetryModal(row) {
      if (this.isUnitCodeNotMatchedLog(row)) {
        this.retryUnitCodeNotMatchedLog(row);
        return;
      }
      if (this.warnMissingHandleContext(row, {
        requireSystem: false
      })) {
        return;
      }
      if (!this.canHandleAsRetry(row)) {
        this.$Message.warning($t("z8gsk47", "请选择目标系统"));
        return;
      }
      const options = this.retrySystemOptions(row);
      this.retryModal = {
        visible: true,
        saving: false,
        row,
        systems: options.map(item => item.value),
        systemOptions: options
      };
    },
    // 多重匹配日志复用告警处理的候选账号查询与人工绑定流程。
    async openCandidates(row) {
      if (this.warnMissingHandleContext(row)) {
        return;
      }
      if (!this.canHandleAsCandidate(row)) {
        this.$Message.warning($t("t1qqda8", "请先选择下游系统"));
        return;
      }
      const {
        data: {
          result,
          retVal,
          msg
        }
      } = await getDownstreamAlertCandidates({
        appId: this.appId,
        unitCode: this.unitCode,
        downstreamSystem: this.primarySystem(row),
        users: [{
          openId: row.openId,
          userCode: row.userCode
        }]
      });
      if (result === 0) {
        var _retVal$results;
        const resultRow = (retVal === null || retVal === void 0 || (_retVal$results = retVal.results) === null || _retVal$results === void 0 ? void 0 : _retVal$results[0]) || {};
        this.candidateModal = {
          visible: true,
          saving: false,
          row,
          candidates: resultRow.candidates || [],
          selectedKey: ""
        };
      } else {
        this.$Message.error((retVal === null || retVal === void 0 ? void 0 : retVal.message) || msg || $t("d1rj434", "操作失败"));
      }
    },
    async confirmRetry() {
      if (!this.retryModal.systems.length) {
        this.$Message.warning($t("z8gsk47", "请选择目标系统"));
        return;
      }
      const row = this.retryModal.row;
      if (this.warnMissingHandleContext(row, {
        requireSystem: false
      })) return;
      this.retryModal.saving = true;
      try {
        const responses = await Promise.all(this.retryModal.systems.map(downstreamSystem => repushDownstreamAccounts({
          appId: this.appId,
          unitCode: this.unitCode,
          downstreamSystem,
          userCodes: [row.userCode]
        })));
        const failed = responses.find(({
          data
        }) => (data === null || data === void 0 ? void 0 : data.result) !== 0);
        if (failed) {
          this.operationResult(failed.data);
        } else {
          const summary = responses.reduce((total, {
            data
          }) => {
            const retVal = (data === null || data === void 0 ? void 0 : data.retVal) || {};
            total.generatedTaskCount += retVal.generatedTaskCount || 0;
            total.successCount += retVal.successCount || 0;
            total.failureCount += retVal.failureCount || 0;
            total.skippedCount += retVal.skippedCount || 0;
            return total;
          }, {
            generatedTaskCount: 0,
            successCount: 0,
            failureCount: 0,
            skippedCount: 0,
            message: $t("8lun1k7", "重试任务已提交")
          });
          this.operationResult({
            result: 0,
            retVal: summary
          });
          this.retryModal.visible = false;
          await this.refreshAfterOperation();
        }
      } finally {
        this.retryModal.saving = false;
      }
    },
    // failureReason=UNIT_CODE_NOT_MATCHED 时，处理按钮直接按当前行唯一 downstreamSystem 重推，不再弹系统选择框。
    async retryUnitCodeNotMatchedLog(row) {
      if (this.warnMissingHandleContext(row, {
        requireSystem: false
      })) {
        return;
      }
      const downstreamSystem = String((row === null || row === void 0 ? void 0 : row.downstreamSystem) || "").trim().toUpperCase();
      if (!downstreamSystem) {
        this.$Message.warning($t("t1qqda8", "请先选择下游系统"));
        return;
      }
      const {
        data
      } = await repushDownstreamAccounts({
        appId: this.appId,
        unitCode: this.unitCode,
        downstreamSystem,
        userCodes: [row.userCode]
      });
      this.operationResult(data);
      if ((data === null || data === void 0 ? void 0 : data.result) === 0) {
        await this.refreshAfterOperation();
      }
    },
    // 挂起且无明确失败原因的日志按文档补偿查询接口处理，不弹重试同步选择框。
    async compensateAccount(row) {
      if (this.warnMissingHandleContext(row)) {
        return;
      }
      const downstreamSystem = this.primarySystem(row);
      if (!downstreamSystem) {
        this.$Message.warning($t("t1qqda8", "请先选择下游系统"));
        return;
      }
      const {
        data
      } = await compensateDownstreamAccounts({
        appId: this.appId,
        unitCode: this.unitCode,
        downstreamSystem,
        userCodes: [row.userCode]
      });
      this.operationResult(data);
      if ((data === null || data === void 0 ? void 0 : data.result) === 0) {
        await this.refreshAfterOperation();
      }
    },
    async manualBind() {
      const row = this.candidateModal.row;
      const candidate = this.candidateModal.candidates.find((item, index) => this.candidateKey(item, index) === this.candidateModal.selectedKey);
      if (!candidate) {
        this.$Message.warning($t("ui2p207", "请选择候选账号"));
        return;
      }
      if (!this.canHandleAsCandidate(row)) return;
      this.candidateModal.saving = true;
      try {
        const {
          data
        } = await manualBindDownstreamAlert({
          appId: this.appId,
          unitCode: this.unitCode,
          downstreamSystem: this.primarySystem(row),
          openId: row.openId,
          userCode: row.userCode,
          downstreamUserKey: candidate.downstreamUserKey,
          downstreamUserCode: candidate.downstreamUserCode
        });
        this.operationResult(data);
        if ((data === null || data === void 0 ? void 0 : data.result) === 0) {
          this.candidateModal.visible = false;
          await this.refreshAfterOperation();
        }
      } finally {
        this.candidateModal.saving = false;
      }
    },
    // 处理动作先看 failureReason；无原因挂起走补偿查询，其余异常保持原重试/绑定流程。
    handleLog(row) {
      if (this.isMultipleMatchedLog(row)) {
        this.openCandidates(row);
        return;
      }
      if (this.isUnitCodeNotMatchedLog(row)) {
        this.retryUnitCodeNotMatchedLog(row);
        return;
      }
      if (this.isPendingWithoutFailureReason(row)) {
        this.compensateAccount(row);
        return;
      }
      this.openRetryModal(row);
    },
    resultText(row) {
      const result = this.normalizedResult(row);
      if (result === RESULT_SUCCESS) return $t("h4sv2", "成功");
      if (result === RESULT_FAILED) return $t("fy1g2", "失败");
      if (result === RESULT_PENDING) return $t("hm7p2", "挂起");
      return result || "—";
    },
    resultClass(row) {
      const result = this.normalizedResult(row);
      if (result === RESULT_SUCCESS) return "success";
      if (result === RESULT_FAILED) return "failed";
      if (result === RESULT_PENDING) return "pending";
      return "";
    },
    dateRangePayload() {
      if (this.filters.dateRange === "ALL") return {};
      const end = new Date();
      const start = new Date();
      if (this.filters.dateRange === "THREE_DAYS") {
        start.setDate(start.getDate() - 2);
      }
      if (this.filters.dateRange === "SEVEN_DAYS") {
        start.setDate(start.getDate() - 6);
      }
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);
      return {
        startTime: this.formatDateTime(start),
        endTime: this.formatDateTime(end)
      };
    },
    formatDateTime(date) {
      const pad = value => String(value).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
    shortSystemName(system) {
      const names = {
        UC: "UC",
        IHOTEL: "iHotel",
        ICATER: "iCater"
      };
      return names[system] || system || "—";
    },
    // 日志时间在列表和详情中统一展示完整年月日时分秒。
    logTime(row) {
      const time = row.historyCreatedAt || row.taskCreatedAt || row.createdAt || row.lastAckTime;
      if (!time) return "—";
      return formatTime(time);
    },
    memberName(row) {
      if (String(row.eventType || row.messageBizType) === "5") {
        return $t("avg4504", "全量对账");
      }
      return row.userName || row.memberName || row.operatorName || row.userCode || row.openId || "—";
    },
    eventText(row) {
      const eventTypeValue = row.eventType !== undefined && row.eventType !== null ? row.eventType : row.messageBizType;
      const eventType = String(eventTypeValue !== null && eventTypeValue !== void 0 ? eventTypeValue : "");
      const sourceType = String(row.sourceType || "").toUpperCase();
      // 人工绑定日志由 sourceType=MANUAL_BIND 明确标识，优先于通用 eventType 映射展示。
      if (eventType === "0" && sourceType === "MANUAL_BIND") {
        return $t("abu00k4", "人工绑定");
      }
      if (row.eventTypeText || row.messageBizTypeText || row.eventName) {
        return row.eventTypeText || row.messageBizTypeText || row.eventName;
      }
      const text = EVENT_TYPE_TEXT[eventType];
      return text || eventType || "—";
    },
    systemList(row) {
      const systems = row.downstreamSystems || row.downstreamSystem || [];
      if (Array.isArray(systems)) return systems.filter(Boolean);
      return String(systems).split(",").map(item => item.trim()).filter(Boolean);
    },
    // 通道文案在列表侧针对 iHotel 做口径覆盖，详情弹窗仍沿用后端原始值。
    channelText(row, forceIhotelApi = false) {
      const systems = this.systemList(row).map(system => String(system || "").toUpperCase());
      if (forceIhotelApi && systems.includes("IHOTEL")) {
        return "API";
      }
      const text = String(row.channelType || row.channelName || row.syncMode || "").toUpperCase();
      if (text.includes("PULL") || text.includes($t("h9gt2", "拉取"))) {
        return $t("a7su624", "主动拉取");
      }
      if (text.includes("BATCH") || text.includes($t("jg91", "批"))) {
        return $t("hjsm2", "批量");
      }
      return row.channelName || "Webhook";
    },
    // 表格文字统一单行省略，避免长成员名或事件文案撑开 pro-table。
    textCell(h, value, type = "") {
      return h("span", {
        class: ["sync-log-text-cell", ...type.split(" ").filter(Boolean)]
      }, value || "—");
    },
    tagNode(h, text, type) {
      return h("span", {
        class: ["sync-log-tag", type]
      }, text);
    },
    renderSystemTags(h, row) {
      const systems = this.systemList(row);
      if (!systems.length) return this.textCell(h, "—");
      return h("div", {
        class: "sync-log-system-tags"
      }, systems.map(system => h("span", {
        class: ["sync-log-system-tag", system.toLowerCase()]
      }, this.shortSystemName(system))));
    },
    renderAction(h, row) {
      const needsHandle = this.needsHandle(row);
      const canViewDetail = this.hasViewableTaskId(row);
      if (!needsHandle && !canViewDetail) {
        return this.textCell(h, "—", "muted");
      }
      return h("button", {
        "class": ["sync-log-action", needsHandle ? "handle" : "view"],
        "on": {
          "click": event => {
            event.stopPropagation();
            needsHandle ? this.handleLog(row) : this.openDetail(row);
          }
        }
      }, [needsHandle ? h("icon", {
        "class": "sync-log-action-icon",
        "attrs": {
          "type": "ios-build-outline",
          "size": 18,
          "title": $t("fs022", "处理")
        }
      }) : h("i", {
        "class": "iconfont icon-yanjing sync-log-view-icon",
        "attrs": {
          "title": $t("ibpi2", "查看")
        }
      })]);
    },
    // 异常日志行按 failureReason/result 判断，成功记录不叠加异常底色。
    rowClassName(row) {
      return this.needsHandle(row) ? "sync-log-row-error" : "";
    },
    // 查看详情时按文档 8.1 调用 payload 详情接口，列表不再使用旧的内联 payload 字段。
    async openDetail(row) {
      this.detailModal = {
        visible: true,
        row,
        loading: true,
        payload: "—"
      };
      try {
        const requestPayload = this.detailPayloadRequest(row);
        if (!requestPayload) return;
        const {
          data: {
            result,
            retVal,
            msg
          }
        } = await getDownstreamLogDetail(requestPayload);
        if (result === 0) {
          this.detailModal.payload = (retVal === null || retVal === void 0 ? void 0 : retVal.data) === undefined || (retVal === null || retVal === void 0 ? void 0 : retVal.data) === null ? "—" : retVal.data;
        } else {
          this.$Message.error((retVal === null || retVal === void 0 ? void 0 : retVal.message) || msg || $t("d1rj434", "操作失败"));
        }
      } finally {
        this.detailModal.loading = false;
      }
    },
    detailPayloadRequest(row) {
      const taskId = this.logTaskId(row);
      const downstreamSystem = this.primarySystem(row);
      if (!this.hasViewableTaskId(row) || !downstreamSystem) {
        this.detailModal.payload = "—";
        return null;
      }
      return {
        appId: this.appId,
        unitCode: this.unitCode,
        downstreamSystem,
        taskId
      };
    },
    logTaskId(row = {}) {
      return row.taskId || row.lastTaskId || row.last_task_id || "";
    },
    // 只有正数 taskId 才代表可回看详情的同步任务，避免人工绑定等无 taskId 记录误展示“查看”。
    hasViewableTaskId(row = {}) {
      return Number(this.logTaskId(row)) > 0;
    },
    pickDetailValue(row = {}, fields) {
      const source = row || {};
      for (const field of fields) {
        if (source[field] !== undefined && source[field] !== null && source[field] !== "") {
          return source[field];
        }
      }
      return "—";
    },
    formatCodeBlock(value) {
      if (value === "—") return value;
      if (typeof value === "object") {
        return JSON.stringify(value, null, 2);
      }
      try {
        return JSON.stringify(JSON.parse(value), null, 2);
      } catch (error) {
        return String(value);
      }
    }
  }
};